import React from 'react';
import './InspectorPanel.css';

export interface WxbInspectorRow {
  key: string;
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
}

export interface WxbInspectorSection {
  key: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  rows?: WxbInspectorRow[];
  content?: React.ReactNode;
}

export interface WxbInspectorPanelProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title: React.ReactNode;
  description?: React.ReactNode;
  status?: React.ReactNode;
  sections?: WxbInspectorSection[];
  footer?: React.ReactNode;
  density?: 'comfortable' | 'compact';
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbInspectorPanel: React.FC<WxbInspectorPanelProps> = ({
  title,
  description,
  status,
  sections,
  footer,
  density = 'comfortable',
  className = '',
  children,
  ...props
}) => (
  <aside className={joinClasses('wxb-inspector-panel', `wxb-inspector-panel-${density}`, className)} {...props}>
    <div className="wxb-inspector-header">
      <div className="wxb-inspector-copy">
        <div className="wxb-inspector-title">{title}</div>
        {description && <div className="wxb-inspector-description">{description}</div>}
      </div>
      {status && <div className="wxb-inspector-status">{status}</div>}
    </div>
    {children}
    {sections && sections.map((section) => (
      <section className="wxb-inspector-section" key={section.key}>
        {(section.title || section.description) && (
          <div className="wxb-inspector-section-header">
            {section.title && <div className="wxb-inspector-section-title">{section.title}</div>}
            {section.description && <div className="wxb-inspector-section-desc">{section.description}</div>}
          </div>
        )}
        {section.rows && (
          <dl className="wxb-inspector-rows">
            {section.rows.map((row) => (
              <div className="wxb-inspector-row" key={row.key}>
                <dt>{row.label}</dt>
                <dd>
                  <span>{row.value}</span>
                  {row.hint && <small>{row.hint}</small>}
                </dd>
              </div>
            ))}
          </dl>
        )}
        {section.content}
      </section>
    ))}
    {footer && <div className="wxb-inspector-footer">{footer}</div>}
  </aside>
);

